import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBag3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBag3"><Path d="M22 21H2V11.4961L11.25 13.5986V14.5H12.75V13.5986L22 11.4961V21Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M17 6H22V9.95801L12.75 12.0596V11.25H11.25V12.0596L2 9.95801V6H7V2H17V6ZM8.5 6H15.5V3.5H8.5V6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBag3;
